<div id="cartOverlay"></div>
<kendo-appbar position="top" positionMode="fixed" style="height: 60px;width:100%;">
  <kendo-appbar-section>
    <img class="loginLogo" src="../../../../assets/images/epclogo.png" />
  </kendo-appbar-section>
  <kendo-appbar-section>
    <!--<h2 class="loginLogoText" (click)="navigateTo('')">{{organizationName}}</h2>-->
    <h2 class="loginLogoText" (click)="navigateTo('')">Welcome to Epc's Redeployment site!</h2>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>

  @if (isVisible) {
  <kendo-appbar-section>
      <button kendoButton class="cartBtn" (click)="showCart($event)" title="Show Cart">
        <span>
          <kendo-icon size="large" name="cart"></kendo-icon>
        </span>
      </button>
  </kendo-appbar-section>

  @if(isAdmin) {
  <kendo-appbar-section>
    <kendo-splitbutton #organization id="btnOrganization"
                       [text]="organizationName"
                       class="organizationDropdownText"
                       fillMode="flat"
                       [data]="organizationItems"
                       [popupSettings]="popupOganziationSettings"
                       (itemClick)="organizationItemClick($event)">

      <ng-template kendoSplitButtonItemTemplate let-dataItem style="width: 250px">
        <div class="splitItemOrganization">
          <fa-icon [icon]="dataItem.icon"></fa-icon>
          {{dataItem.text}}
        </div>
      </ng-template>
    </kendo-splitbutton>
  </kendo-appbar-section>
  }

  @if(!isAdmin) {
  <kendo-appbar-section>
    <div class="organizationDropdownText"> {{organizationName}}</div>
  </kendo-appbar-section>
  }


  <kendo-appbar-section>
    <kendo-splitbutton #user id="btnUser"
                       [svgIcon]="helpIcon"
                       [text]="helpText"
                       title="Help"
                       arrowButtonIcon="chevron-down"
                       [data]="helpMenuItems"
                       [popupSettings]="popupSettings"
                       (itemClick)="menuItemClick($event)">

      <ng-template kendoSplitButtonItemTemplate let-dataItem style="width: 175px">
        <div class="splitItem">
          <fa-icon [icon]="dataItem.icon"></fa-icon>
          {{dataItem.text}}
        </div>
      </ng-template>
    </kendo-splitbutton>
  </kendo-appbar-section>


  <kendo-appbar-section>
    <div class="spacer">&nbsp;</div>
  </kendo-appbar-section>


  <kendo-appbar-section>
    <kendo-splitbutton #user id="btnUser"
                       [text]="userName"
                       arrowButtonIcon="chevron-down"
                       [data]="menuItems"
                       [popupSettings]="popupSettings"
                       (itemClick)="menuItemClick($event)">

      <ng-template kendoSplitButtonItemTemplate let-dataItem style="width: 175px">
        <div class="splitItem">
          <fa-icon [icon]="dataItem.icon"></fa-icon>
          {{dataItem.text}}
        </div>
      </ng-template>
    </kendo-splitbutton>
  </kendo-appbar-section>
  }

</kendo-appbar>

@if(isVisible) {
<app-side-cart></app-side-cart>
}

<kendo-stacklayout orientation="vertical" style="width:100%">

  @if (openTimeout) {
  <kendo-dialog title="Attention!" [animation]="true" (close)="closeTimeoutDialog()">
    <p>
      Certain items you've reserved went past the 30 minute time cap: <br>
    </p>

    @for(item of timedOutCartItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.itemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    @for(item of timedOutCartMiscItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.miscellaneousItemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    <p>
      The other items in your cart have been removed and returned to available status. <br>
      Please re-add your items and checkout within the 30 minute mark.
    </p>

    <kendo-dialog-actions>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="acknowledgeTimedOutItems()" [svgIcon]="dialogYes">
        Acknowledge
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="acknowledgeTimedOutItems()">
        Acknowledge
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
